// 最大回収は60000だが、足が出るとその分rangeがあがるので-1000する。
export const maxAnsweredLimit = 60000;
export const maxAnswered = maxAnsweredLimit - 1000;
